import { lazy } from "react";
import Loadable from "components/Loadable";

const UniversityList = Loadable(
  lazy(() => import("features/university/components/List"))
);
const UniversityPage = Loadable(
  lazy(() => import("features/university/components/Page"))
);

const routes = {
  path: "university",
  children: [
    { path: "", element: <UniversityList /> },
    { path: "add", element: <UniversityPage /> },
    { path: "edit/:id?", element: <UniversityPage /> },
  ],
};

export default routes;
